import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { rootElementId } from "./utils/Utils";
import './i18n';
import './App.css'; // Add this line

const el = document.getElementById(rootElementId);
const root = ReactDOM.createRoot(el);

root.render(<App />);
